export const isEmail = (value: string) => {
  const regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regexEmail.test(value);
};

export const isEmptyString = (value?: string) => (value ? value.trim().length === 0 : true);

export const deprecate = (message: string) => {
  if (window.location.hostname === 'localhost') {
    throw new Error(`Deprecation error: ${message}`);
  }
};

// Adapted from: https://github.com/gregberge/react-merge-refs/blob/main/src/index.tsx
export const mergeRefs = <T>(...refs: React.Ref<T | null>[]) => {
  return (node: T | null) => {
    refs.forEach((r) => {
      if (typeof r === 'function') {
        r(node);
      } else if (r) {
        (r as React.MutableRefObject<T | null>).current = node;
      }
    });
  };
};
